import React, { Component } from "react";
import moment from "moment-timezone";
import { withRouter } from "react-router-dom";
import { languages } from "../constants/languages";
import vrsn from "../constants/vrsn";

class AnonymousTournamentContainer extends Component {
  state = {
    name: "",
    date: moment().tz(
      (this.props.userData || {}).timezone || "Europe/Amsterdam"
    ),
    invalidName: false,
    submitDisabled: false,
  };

  UNSAFE_componentWillMount = () => {
    this.handleCreate();
  };

  handleCreate = () => {
    if (this.props.user.isAnonymous) {
      if (window.firebase.analytics) {
        window.firebase.analytics().logEvent("new_user_new_tournament");
      }
    }
    if (!this.state.submitDisabled) {
      this.setState({ submitDisabled: true });
      let tournament = {
        name: this.state.name,
        date: this.state.date
          .tz((this.props.userData || {}).timezone || "Europe/Amsterdam")
          .unix(),
        uid: this.props.user.uid,
        new: true,
        seenOffer: true,
        vrsn: vrsn,
        lang: [languages.getLanguage()],
        prm: this.props.promo === "promo" || this.props.promo === "promo/",
      };
      if ((this.props.userData || {}).isPSD) {
        tournament["isPSD"] = true;
        tournament["color"] = "#000000";
        tournament["sponsors"] = [
          "https://www.prosoccerdata.com/img/assets/logo.png",
        ];
        tournament["sponsorLinks"] = ["https://www.prosoccerdata.com"];
      }
      if ((this.props.userData || {}).isSporta) {
        tournament["isSporta"] = true;
      }
      if ((this.props.userData || {})["RV"]) {
        tournament["RV"] = true;
      }
      if ((this.props.userData || {})["arenal"]) {
        tournament["arenal"] = true;
      }
      if (this.props.psdCode && this.props.codeValid) {
        tournament["crqpsd"] = this.props.psdCode;
        tournament["color"] = "#000000";
        tournament["sponsors"] = [
          "https://www.prosoccerdata.com/img/assets/logo.png",
        ];
        tournament["sponsorLinks"] = ["https://www.prosoccerdata.com"];
      }
      if (this.props.iResCode && this.props.iResCodeValid) {
        tournament["iResCode"] = this.props.iResCode;
        tournament["sponsors"] = [
          "https://firebasestorage.googleapis.com/v0/b/tournament-uploads/o/baanreserveren.nl.png?alt=media&token=08499cb8-4983-40ae-af2a-c800382a7289",
        ];
        tournament["sponsorLinks"] = ["https://www.baanreserveren.nl"];
      }
      let db = window.firebase.firestore();

      let batch = db.batch();

      let tournamentDoc = db.collection("tournaments").doc();
      let divisionDoc = tournamentDoc.collection("divisions").doc("0");

      batch.set(tournamentDoc, tournament);
      batch.set(divisionDoc, { name: "" });
      batch
        .commit()
        .then((doc) => {
          let location = "/tournament/" + tournamentDoc.id + "/new";
          if (this.props.psdCode && this.props.codeValid) {
            location =
              "/tournament/" + tournamentDoc.id + "/new/" + this.props.psdCode;
          }
          this.props.history.push(location);
        })
        .catch((error) => {
          console.log(error.message);
          this.setState({ submitDisabled: false });
        });
    } else {
      this.setState({ invalidName: true });
    }
  };

  render() {
    return <div />;
  }
}

export default withRouter(AnonymousTournamentContainer);
